<template>
  <div>
    <vx-card>
      <vs-table
        no-data-text="Операторов нет"
        search
        stripe
        :data="members">
        <template slot="header">
          <vs-button @click.prevent="openPopup">Добавить оператора</vs-button>
        </template>
        <template slot="thead">
          <vs-th sort-key="name">
            Имя
          </vs-th>
          <vs-th sort-key="surname">
            Фамилия
          </vs-th>
          <vs-th sort-key="email">
            Email
          </vs-th>
          <vs-th sort-key="actions">
            Действия
          </vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
            <vs-td :data="data[indextr].name">
              <div class="flex items-center">
                <vs-avatar v-if="data[indextr].profile_image_url" :src="data[indextr].profile_image_url" class="mr-4" />
                {{ data[indextr].name.split(' ')[0] }}
              </div>
            </vs-td>

            <vs-td :data="data[indextr].name">
              {{ data[indextr].name.split(' ')[1] }}
            </vs-td>

            <vs-td :data="data[indextr].email">
              {{ data[indextr].email }}
            </vs-td>

            <vs-td :data="data[indextr].actions">
              <div class="flex items-center justify-end">
                <vs-button type="flat" size="large" icon="link_off" @click="clickOnLinkOffMember(data[indextr].email)"></vs-button>
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>

    <vs-popup :active.sync="popupIsActive" title="Добавление оператора в группу">
      <div v-if="allOperators.length === 0">
        <p>Все операторы уже добавлены</p>
      </div>
      <div v-else class="vx-row items-end">
        <div class="vx-col w-full lg:w-3/4 mb-6">
          <div class="vs-input--label">Операторы:</div>
          <SelectInPopup
            multiple
            label="name"
            v-model="addingMembers"
            :reduce="option => option.email"
            :options="allOperators"
          />
        </div>
        <div class="vx-col w-full lg:w-1/4 mb-6">
          <vs-button class="w-full" @click.prevent="submitAddMembers">Добавить</vs-button>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import Groups from '../../api/http/models/Groups'
import Operators from '../../api/http/models/Operators'

export default {
  props: {
    companySlug: {
      type: String,
      required: true
    },
    groupSlug: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      popupIsActive: false,
      allOperators: [],
      members: [],
      addingMembers: [],
      removedMember: {}
    }
  },
  async created () {
    const response = await Groups.getMembers(this.companySlug, this.groupSlug)

    this.members = response.data || []
  },
  methods: {
    clickOnLinkOffMember (email) {
      this.removedMember = this.members.find(member => email === member.email)
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Вы действительно хотите удалить «${this.removedMember.name}» из группы операторов?`,
        text: `Оператор «${this.removedMember.name}» будет удален из группы.`,
        accept: this.linkOffMember,
        acceptText: 'Да, хочу',
        cancelText: 'Нет'
      })
    },
    async linkOffMember () {
      const response = await Groups.removeMembers(this.companySlug, this.groupSlug, {
        emails: [this.removedMember.email]
      })

      if (response.status === 'success' && response.data) {
        this.members = response.data
        this.$vs.notify({
          color: 'success',
          title: `Оператор «${this.removedMember.name}» был удален из группы.`,
          text: ''
        })
      }
    },
    async openPopup () {
      const operators = await Operators.getAll(this.companySlug)

      if (operators.data) {
        this.allOperators = operators.data.filter(operator => {
          return !this.members.find(member => operator.email === member.email)
        })

        this.popupIsActive = true
      }
    },
    async submitAddMembers () {
      const response = await Groups.addMembers(this.companySlug, this.groupSlug, {
        emails: this.addingMembers
      })

      if (response.status === 'success' && response.data) {
        this.addingMembers = []
        this.members = response.data
        this.popupIsActive = false
        this.$vs.notify({
          color: 'success',
          title: 'Успешно добавленно',
          text: 'Список участников группы обновлен'
        })
      }
    }
  }
}
</script>
